import { call, put, takeLatest, all, select, delay } from "redux-saga/effects";
import {
  UPDATING_USER_PICTURE,
  UPDATING_USER_PICTURE_ERROR,
  UPDATING_USER_PICTURE_SUCCESS,
  SETTINGS_USER_CHANGE_LANGUAGE,
  GDPR_EXPORT_DATA_REQUESTING,
  GDPR_EXPORT_DATA_SUCCESS,
  GDPR_EXPORT_DATA_ERROR,
  GDPR_DELETE_ACCOUNT_SUCCESS,
  GDPR_DELETE_ACCOUNT_ERROR,
  GDPR_DELETE_ACCOUNT_REQUESTING,
  SHOW_ALERT,
} from "./constants";

import { deleteMyUserRequest } from "@microdoing/shared/services/user/actions";
import { modifyUser } from "../user/actions";
import { hideAlert, showAlert } from "./actions";
import { fetchApi } from "../api";
import i18n from "../../i18n";
import { REHYDRATE } from "redux-persist";
import uploadS3 from "./uploadS3"; // à vérifier
import { getUserId } from "../user/selectors";

const endPoints = {
  uploadImage: "/v1/upload/sign-s3?",
  updateUserPicture: "/v1/users/update-picture",
  gdprDeleteAccount: "/v1/users/gdpr/delete-account",
  gdprExportData: "/v1/users/gdpr/export-data",
};

const uploadImageApi = data => {
  return fetchApi(
    `${endPoints.uploadImage}file-name=${data.name}&file-type=image/jpg`,
    {},
    "get",
  );
};

export const updateUserPictureApi = data => {
  return fetchApi(endPoints.updateUserPicture, data, "post");
};

export const gdprDeleteAccountApi = data => {
  return fetchApi(endPoints.gdprDeleteAccount, data, "post");
};

export const gdprExportDataApi = data => {
  return fetchApi(endPoints.gdprExportData, data, "post");
};

function* changeLanguageFlow(action) {
  const language = action.payload;
  i18n.locale = language;
}

function* rehydrateLanguageFlow(action) {
  const language = yield select(state => state.profileSettings.language);
  i18n.locale = language;
}

function* updateUserPictureFlow(action) {
  try {
    const data = action.payload;

    const resData = yield call(uploadImageApi, data);
    const { signedRequest, url } = resData;

    const response = yield call(uploadS3, signedRequest, data.uri);


    const { userId, picture } = data;

    const result = yield call(updateUserPictureApi, { userId, picture });
    yield put(modifyUser(result));
    yield put({ type: UPDATING_USER_PICTURE_SUCCESS });
  } catch (error) {
    console.log(error);
    yield put({ type: UPDATING_USER_PICTURE_ERROR, error });
  }
}

function* gdprDeleteAccountFlow(action) {
  try {
    const result = yield call(gdprDeleteAccountApi, action.payload);
    const userId = yield select(getUserId);
    yield put(
      showAlert({
        title: i18n.t("gdpr-delete-account-success"),
        message: i18n.t("gdpr-delete-account-success"),
      }),
    );

    yield put({ type: GDPR_DELETE_ACCOUNT_SUCCESS });
    yield put(deleteMyUserRequest({ userId }));
  } catch (error) {
    console.log(error);
    yield put({ type: GDPR_DELETE_ACCOUNT_ERROR, error });
  }
}

function* displayAlertFlow(action) {
  try {
    yield delay(2500);
    yield put(hideAlert());
  } catch (error) {
    console.log(error);
  }
}

function* gdprExportDataFlow(action) {
  try {
    const result = yield call(gdprExportDataApi, action.payload);
    yield put({ type: GDPR_EXPORT_DATA_SUCCESS });
    yield put(
      showAlert({
        title: i18n.t("gdpr-export-data-success"),
        message: i18n.t("gdpr-export-data-success"),
      }),
    );
  } catch (error) {
    console.log(error);
    yield put({ type: GDPR_EXPORT_DATA_ERROR, error });
  }
}

function* settingsWatcher() {
  yield all([
    takeLatest(UPDATING_USER_PICTURE, updateUserPictureFlow),
    takeLatest(SETTINGS_USER_CHANGE_LANGUAGE, changeLanguageFlow),
    takeLatest(REHYDRATE, rehydrateLanguageFlow),
    takeLatest(GDPR_EXPORT_DATA_REQUESTING, gdprExportDataFlow),
    takeLatest(GDPR_DELETE_ACCOUNT_REQUESTING, gdprDeleteAccountFlow),
    takeLatest(SHOW_ALERT, displayAlertFlow),
  ]);
}

export default settingsWatcher;
